import React from "react";

export const Services = (props) => {
  return (
    <div id="services" className="text-center pt-md-4 pt-2">
      <div className="container">
        <div className="section-title section-title mb-md-4 mb-2">
          <h2 className="mb-md-3 mb-1">Horário de Cultos</h2>
        </div>
        <div className="row justify-content-center">
          {props.data
            ? props.data.map((d, i) => (
                <div 
                  key={`${d.name}-${i}`} 
                  className="col-12 col-sm-10 col-md-6 "
                >
                  <div className="service-card d-flex flex-column align-items-center text-center ">
                    <i className={d.icon + " mb-3"}></i>
                    <div className="service-desc">
                      <h3 className="fw-bold">{d.name}</h3>
                      <p className="mb-0">{d.text}</p>
                    </div>
                  </div>
                </div>
              ))
            : "loading"}
        </div>
      </div>
    </div>
  );
};